// // src/components/OrderList/OrderRow.jsx

// import React, { useEffect, useRef } from "react";
// import { TTN_EDITABLE_STATUSES } from "./constants";
// import Swal from "sweetalert2";
// import {
//   fmtDate,
//   ts,
//   shortId,
//   safeMoney,
//   getOrderTotal,
//   getBuyerFullName,
//   getBuyerPhone,
//   getReceiverFullName,
//   getReceiverPhone,
//   getUserCategory,
//   getStatus,
//   getTtn,
//   isBusinessPartnerOrder,
//   getPaymentMethodRaw,
//   getPaymentMethodLabel,
//   getPaymentProviderLabel,
//   getPaymentStatusLabel,
//   getInvoiceInfo,
//   getDeliveryProviderLabel,
//   getDeliveryLine,
//   isPaidOrder,
//   isCanceledOrder,
// } from "./orderUtils";

// export default function OrderRow({
//   styles,
//   row,
//   isOpen,
//   toggleExpand,

//   // status edit
//   editingStatusId,
//   statusDraft,
//   setStatusDraft,
//   beginEditStatus,
//   saveStatus,
//   onStatusKey,
//   statusOptions,

//   // ttn edit
//   editingTtnId,
//   ttnDraft,
//   setTtnDraft,
//   beginEditTTN,
//   saveTTN,
//   saveTTNAndSetStatus,
//   cancelEditTTN,
//   onTtnKey,
//   // items edit
//   editingItemsId,
//   itemsDraft,
//   newPid,
//   setNewPid,
//   newQty,
//   setNewQty,
//   savingItems,
//   beginEditItems,
//   cancelEditItems,
//   setItemQty,
//   removeDraftItem,
//   addDraftItem,
//   saveItems,
// }) {
//   const { order, choice } = row;
//   const id = order.id;

//   const status = getStatus(order);
//   const buyer = getBuyerFullName(order);
//   const sum = safeMoney(getOrderTotal(order));

//   const isBiz = isBusinessPartnerOrder(order);
//   const payLabel = isBiz ? getPaymentMethodLabel(order) : "—";
//   const invoice = isBiz ? getInvoiceInfo(order) : null;

//   const invoiceCell = !isBiz ? (
//     "—"
//   ) : getPaymentMethodRaw(order) !== "invoice" ? (
//     "—"
//   ) : invoice?.invoiceUrl ? (
//     <a href={invoice.invoiceUrl} target="_blank" rel="noreferrer">
//       {invoice.invoiceNumber ? invoice.invoiceNumber : "Відкрити рахунок"}
//     </a>
//   ) : (
//     "ще не сформовано"
//   );

//   const paid = isPaidOrder(order) ? "Так" : "Ні";
//   const canceled = isCanceledOrder(order) ? "Так" : "Ні";

//   // focus refs (мінімально)
//   const statusRef = useRef(null);
//   const ttnRef = useRef(null);

//   useEffect(() => {
//     if (editingStatusId === id && statusRef.current) statusRef.current.focus();
//   }, [editingStatusId, id]);

//   useEffect(() => {
//     if (editingTtnId === id && ttnRef.current) ttnRef.current.focus();
//   }, [editingTtnId, id]);

//   const canEditTtn = TTN_EDITABLE_STATUSES.has(status);
//   const copyToClipboard = async (text) => {
//     try {
//       await navigator.clipboard.writeText(String(text || ""));
//       Swal.fire({
//         icon: "success",
//         title: "Скопійовано",
//         timer: 800,
//         showConfirmButton: false,
//       });
//     } catch {
//       // fallback
//       const t = document.createElement("textarea");
//       t.value = String(text || "");
//       document.body.appendChild(t);
//       t.select();
//       document.execCommand("copy");
//       document.body.removeChild(t);
//       Swal.fire({
//         icon: "success",
//         title: "Скопійовано",
//         timer: 800,
//         showConfirmButton: false,
//       });
//     }
//   };
//   const currentTtn = getTtn(order);

//   return (
//     <>
//       {/* MAIN ROW */}
//       <tr className={styles.row} onDoubleClick={() => toggleExpand(id)}>
//         <td className={styles.colCheck}>
//           <input type="checkbox" />
//         </td>

//         <td>{fmtDate(ts(order))}</td>

//         <td className={styles.idCell}>
//           №{shortId(order.id || order.orderId || order.uid)}
//         </td>

//         <td className={styles.buyerCell}>{buyer || "—"}</td>

//         {/* STATUS CELL */}
//         <td
//           className={styles.statusCell}
//           onDoubleClick={(e) => beginEditStatus(order, e)}
//         >
//           {editingStatusId === id ? (
//             <select
//               ref={statusRef}
//               value={statusDraft || "Очікує підтвердження"}
//               onChange={(e) => setStatusDraft(e.target.value)}
//               onBlur={() => saveStatus(id)}
//               onKeyDown={(e) => onStatusKey(e, id)}
//               className={styles.statusSelect}
//             >
//               {statusOptions.map((opt) => (
//                 <option key={opt} value={opt}>
//                   {opt}
//                 </option>
//               ))}
//             </select>
//           ) : (
//             <span className={styles.statusBadge}>{status}</span>
//           )}
//         </td>

//         <td>{payLabel}</td>
//         <td>{invoiceCell}</td>

//         <td>{paid}</td>
//         <td>{canceled}</td>

//         <td className={styles.colSum}>{sum}</td>

//         <td className={styles.positionsCell}>
//           {choice.length > 0 ? (
//             <>
//               {choice[0]?.bookName || choice[0]?.name || "Товар"}
//               {choice.length > 1 && (
//                 <span className={styles.morePos}>
//                   {" "}
//                   +{choice.length - 1} поз.
//                 </span>
//               )}
//             </>
//           ) : (
//             "—"
//           )}
//         </td>
//       </tr>

//       {/* DETAILS */}
//       {isOpen && (
//         <tr className={styles.detailsRow}>
//           <td></td>
//           <td colSpan={10}>
//             <div className={styles.detailsBox}>
//               {/* LEFT */}
//               <div className={styles.colLeft}>
//                 <h4>Дані замовника</h4>

//                 <p>
//                   <b>ПІБ:</b> {buyer || "—"}
//                 </p>
//                 <p>
//                   <b>Телефон:</b> {getBuyerPhone(order) || "—"}
//                 </p>

//                 <p>
//                   <b>Отримувач:</b> {getReceiverFullName(order) || "—"}
//                 </p>
//                 <p>
//                   <b>Телефон отримувача:</b> {getReceiverPhone(order) || "—"}
//                 </p>

//                 <p>
//                   <b>Категорія:</b> {getUserCategory(order) || "—"}
//                 </p>

//                 <p>
//                   <b>Спосіб оплати:</b>{" "}
//                   {isBiz ? getPaymentMethodLabel(order) : order.pay || "—"}
//                 </p>

//                 <p>
//                   <b>Статус оплати:</b> {getPaymentStatusLabel(order)}
//                 </p>

//                 <p>
//                   <b>Провайдер оплати:</b> {getPaymentProviderLabel(order)}
//                 </p>

//                 {/* Invoice block */}
//                 {isBiz && getPaymentMethodRaw(order) === "invoice" && (
//                   <div style={{ marginTop: 10 }}>
//                     <p>
//                       <b>Рахунок:</b> {invoice?.invoiceNumber || "—"}
//                       {invoice?.invoiceDate
//                         ? ` (дата: ${invoice.invoiceDate})`
//                         : ""}
//                     </p>

//                     {invoice?.invoiceUrl ? (
//                       <p>
//                         <a
//                           href={invoice.invoiceUrl}
//                           target="_blank"
//                           rel="noreferrer"
//                         >
//                           Відкрити рахунок{" "}
//                           {invoice?.fileType ? `(.${invoice.fileType})` : ""}
//                         </a>
//                       </p>
//                     ) : (
//                       <p style={{ color: "#777" }}>Рахунок ще не сформовано.</p>
//                     )}
//                   </div>
//                 )}

//                 <p>
//                   <b>Адреса доставки:</b> {getDeliveryLine(order)}
//                 </p>

//                 <p>
//                   <b>Загальна вартість:</b> {sum}
//                 </p>

//                 <p>
//                   <b>Статус замовлення:</b> {status}
//                 </p>

//                 <p>
//                   <b>Створено:</b>{" "}
//                   {fmtDate(ts(order)) || order?.createdAtDisplay || "—"}
//                 </p>
//               </div>

//               {/* RIGHT */}
//               <div className={styles.colRight}>
//                 <h4>Логістика</h4>

//                 <p>
//                   <b>Служба доставки:</b> {getDeliveryProviderLabel(order)}
//                 </p>

//                 <div className={styles.ttnRow}>
//                   <b>ТТН Нової пошти:&nbsp;</b>

//                   {editingTtnId === id ? (
//                     <>
//                       <input
//                         ref={ttnRef}
//                         value={ttnDraft}
//                         onChange={(e) => setTtnDraft(e.target.value)}
//                         onKeyDown={(e) => onTtnKey(e, id)}
//                         placeholder="Введіть номер ТТН (8–14 цифр)"
//                         className={styles.ttnInput}
//                       />

//                       <button
//                         type="button"
//                         className={styles.saveBtn}
//                         onMouseDown={(e) => e.preventDefault()}
//                         onClick={() => saveTTN(id)}
//                       >
//                         Зберегти ТТН
//                       </button>

//                       <button
//                         type="button"
//                         className={styles.saveBtn}
//                         onMouseDown={(e) => e.preventDefault()}
//                         onClick={() => saveTTNAndSetStatus(id)}
//                       >
//                         ТТН НП внесено
//                       </button>

//                       <button
//                         type="button"
//                         className={styles.cancelBtn}
//                         onMouseDown={(e) => e.preventDefault()}
//                         onClick={cancelEditTTN}
//                       >
//                         Скасувати
//                       </button>
//                     </>
//                   ) : currentTtn ? (
//                     <>
//                       <a
//                         href={`https://tracking.novaposhta.ua/#/ua?cargo_number=${currentTtn}`}
//                         target="_blank"
//                         rel="noreferrer"
//                         className={styles.ttnLink}
//                       >
//                         {currentTtn}
//                       </a>

//                       {canEditTtn && (
//                         <button
//                           type="button"
//                           className={styles.editBtn}
//                           onClick={() => beginEditTTN(order)}
//                         >
//                           Змінити
//                         </button>
//                       )}
//                     </>
//                   ) : canEditTtn ? (
//                     <button
//                       type="button"
//                       className={styles.addBtn}
//                       onClick={() => beginEditTTN(order)}
//                     >
//                       Додати ТТН
//                     </button>
//                   ) : (
//                     <span>— (доступно після статусу «Взято в роботу»)</span>
//                   )}
//                 </div>
//                 <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
//                   <button
//                     type="button"
//                     className={styles.editBtn}
//                     onClick={() => beginEditItems(order)}
//                   >
//                     Редагувати позиції
//                   </button>

//                   {editingItemsId === id && (
//                     <button
//                       type="button"
//                       className={styles.cancelBtn}
//                       onClick={cancelEditItems}
//                     >
//                       Закрити редактор
//                     </button>
//                   )}
//                 </div>
//                 <h4>Позиції ({choice.length})</h4>

//                 {choice.length === 0 && (
//                   <div className={styles.empty}>Позицій немає</div>
//                 )}

//                 {choice.map((el, i) => {
//                   const price =
//                     el?.finalPrice ?? el?.price ?? el?.unitPrice ?? 0;
//                   const qty = Number(el?.quantity ?? el?.qty ?? 1) || 1;

//                   return (
//                     <div key={i} className={styles.item}>
//                       <div className={styles.itemName}>
//                         {el?.bookName || el?.name || `Товар ${i + 1}`}
//                       </div>
//                       <div className={styles.itemQty}>x{qty}</div>
//                       <div className={styles.itemPrice}>{safeMoney(price)}</div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </td>
//         </tr>
//       )}
//     </>
//   );
// }
// src/components/OrderList/OrderRow.jsx

import React, { useEffect, useRef } from "react";
import { TTN_EDITABLE_STATUSES } from "./constants";
import Swal from "sweetalert2";
import ProductPicker from "./ProductPicker";
import {
  fmtDate,
  ts,
  shortId,
  safeMoney,
  getOrderTotal,
  getBuyerFullName,
  getBuyerPhone,
  getReceiverFullName,
  getReceiverPhone,
  getUserCategory,
  getStatus,
  getTtn,
  getPaymentMethodRaw,
  getPaymentMethodLabel,
  getPaymentProviderLabel,
  getPaymentStatusLabel,
  getInvoiceInfo,
  hasInvoice,
  getDeliveryProviderLabel,
  getDeliveryLine,
  isPaidOrder,
  isCanceledOrder,
  getItemFinalUnitPrice,
} from "./orderUtils";

export default function OrderRow({
  styles,
  row,
  isOpen,
  toggleExpand,

  // status edit
  editingStatusId,
  statusDraft,
  setStatusDraft,
  beginEditStatus,
  saveStatus,
  onStatusKey,
  statusOptions,

  // ttn edit
  editingTtnId,
  ttnDraft,
  setTtnDraft,
  beginEditTTN,
  saveTTN,
  saveTTNAndSetStatus,
  cancelEditTTN,
  onTtnKey,
  // items edit
  editingItemsId,
  itemsDraft,
  newPid,
  setNewPid,
  newQty,
  setNewQty,
  savingItems,
  beginEditItems,
  cancelEditItems,
  setItemQty,
  removeDraftItem,
  addDraftItem,
  saveItems,
}) {
  const { order, choice } = row;
  const id = order.id;
  const [pickedProduct, setPickedProduct] = React.useState(null);
  const [addQty, setAddQty] = React.useState(1);

  useEffect(() => {
    if (editingItemsId === id) {
      setPickedProduct(null);
      setAddQty(1);
    }
  }, [editingItemsId, id]);
  const status = getStatus(order);
  const buyer = getBuyerFullName(order);
  const sum = safeMoney(getOrderTotal(order));

  const payLabel = getPaymentMethodLabel(order);
  const invoice = getInvoiceInfo(order);
  const showInvoice = hasInvoice(order);

  const invoiceCell = !showInvoice ? (
    "—"
  ) : invoice?.invoiceUrl ? (
    <a href={invoice.invoiceUrl} target="_blank" rel="noreferrer">
      {invoice.invoiceNumber ? invoice.invoiceNumber : "Відкрити рахунок"}
    </a>
  ) : invoice?.invoiceNumber ? (
    invoice.invoiceNumber
  ) : (
    "ще не сформовано"
  );

  const paid = isPaidOrder(order) ? "Так" : "Ні";
  const canceled = isCanceledOrder(order) ? "Так" : "Ні";

  // focus refs (мінімально)
  const statusRef = useRef(null);
  const ttnRef = useRef(null);

  useEffect(() => {
    if (editingStatusId === id && statusRef.current) statusRef.current.focus();
  }, [editingStatusId, id]);

  useEffect(() => {
    if (editingTtnId === id && ttnRef.current) ttnRef.current.focus();
  }, [editingTtnId, id]);

  const canEditTtn = TTN_EDITABLE_STATUSES.has(status);
  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(String(text || ""));
      Swal.fire({
        icon: "success",
        title: "Скопійовано",
        timer: 800,
        showConfirmButton: false,
      });
    } catch {
      // fallback
      const t = document.createElement("textarea");
      t.value = String(text || "");
      document.body.appendChild(t);
      t.select();
      document.execCommand("copy");
      document.body.removeChild(t);
      Swal.fire({
        icon: "success",
        title: "Скопійовано",
        timer: 800,
        showConfirmButton: false,
      });
    }
  };
  const currentTtn = getTtn(order);

  return (
    <>
      {/* MAIN ROW */}
      <tr className={styles.row} onDoubleClick={() => toggleExpand(id)}>
        <td className={styles.colCheck}>
          <input type="checkbox" />
        </td>

        <td>{fmtDate(ts(order))}</td>

        <td className={styles.idCell}>
          №{shortId(order.id || order.orderId || order.uid)}
        </td>

        <td className={styles.buyerCell}>{buyer || "—"}</td>

        {/* STATUS CELL */}
        <td
          className={styles.statusCell}
          onDoubleClick={(e) => beginEditStatus(order, e)}
        >
          {editingStatusId === id ? (
            <select
              ref={statusRef}
              value={statusDraft || "Очікує підтвердження"}
              onChange={(e) => setStatusDraft(e.target.value)}
              onBlur={() => saveStatus(id)}
              onKeyDown={(e) => onStatusKey(e, id)}
              className={styles.statusSelect}
            >
              {statusOptions.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          ) : (
            <span className={styles.statusBadge}>{status}</span>
          )}
        </td>

        <td>{payLabel}</td>
        <td>{invoiceCell}</td>

        <td>{paid}</td>
        <td>{canceled}</td>

        <td className={styles.colSum}>{sum}</td>

        <td className={styles.positionsCell}>
          {choice.length > 0 ? (
            <>
              {choice[0]?.bookName || choice[0]?.name || "Товар"}
              {choice.length > 1 && (
                <span className={styles.morePos}>
                  {" "}
                  +{choice.length - 1} поз.
                </span>
              )}
            </>
          ) : (
            "—"
          )}
        </td>
      </tr>

      {/* DETAILS */}
      {isOpen && (
        <tr className={styles.detailsRow}>
          <td></td>
          <td colSpan={10}>
            <div className={styles.detailsBox}>
              {/* LEFT */}
              <div className={styles.colLeft}>
                <h4>Дані замовника</h4>

                <p>
                  <b>ПІБ:</b> {buyer || "—"}
                </p>
                <p>
                  <b>Телефон:</b> {getBuyerPhone(order) || "—"}
                </p>

                <p>
                  <b>Отримувач:</b> {getReceiverFullName(order) || "—"}
                </p>
                <p>
                  <b>Телефон отримувача:</b> {getReceiverPhone(order) || "—"}
                </p>

                <p>
                  <b>Категорія:</b> {getUserCategory(order) || "—"}
                </p>

                <p>
                  <b>Спосіб оплати:</b> {payLabel}
                </p>

                <p>
                  <b>Статус оплати:</b> {getPaymentStatusLabel(order)}
                </p>

                <p>
                  <b>Провайдер оплати:</b> {getPaymentProviderLabel(order)}
                </p>

                {/* Invoice block */}
                {showInvoice && (
                  <div style={{ marginTop: 10 }}>
                    <p>
                      <b>Рахунок:</b> {invoice?.invoiceNumber || "—"}
                      {invoice?.invoiceDate
                        ? ` (дата: ${invoice.invoiceDate})`
                        : ""}
                    </p>

                    {invoice?.invoiceUrl ? (
                      <p>
                        <a
                          href={invoice.invoiceUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Відкрити рахунок{" "}
                          {invoice?.fileType ? `(.${invoice.fileType})` : ""}
                        </a>
                      </p>
                    ) : (
                      <p style={{ color: "#777" }}>Рахунок ще не сформовано.</p>
                    )}
                  </div>
                )}

                <p>
                  <b>Адреса доставки:</b> {getDeliveryLine(order)}
                </p>

                <p>
                  <b>Загальна вартість:</b> {sum}
                </p>

                <p>
                  <b>Статус замовлення:</b> {status}
                </p>

                <p>
                  <b>Створено:</b>{" "}
                  {fmtDate(ts(order)) || order?.createdAtDisplay || "—"}
                </p>
              </div>

              {/* RIGHT */}
              <div className={styles.colRight}>
                <h4>Логістика</h4>

                <p>
                  <b>Служба доставки:</b> {getDeliveryProviderLabel(order)}
                </p>

                <div className={styles.ttnRow}>
                  <b>ТТН Нової пошти:&nbsp;</b>

                  {editingTtnId === id ? (
                    <>
                      <input
                        ref={ttnRef}
                        value={ttnDraft}
                        onChange={(e) => setTtnDraft(e.target.value)}
                        onKeyDown={(e) => onTtnKey(e, id)}
                        placeholder="Введіть номер ТТН (8–14 цифр)"
                        className={styles.ttnInput}
                      />

                      <button
                        type="button"
                        className={styles.saveBtn}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => saveTTN(id)}
                      >
                        Зберегти ТТН
                      </button>

                      <button
                        type="button"
                        className={styles.saveBtn}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => saveTTNAndSetStatus(id)}
                      >
                        ТТН НП внесено
                      </button>

                      <button
                        type="button"
                        className={styles.cancelBtn}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={cancelEditTTN}
                      >
                        Скасувати
                      </button>
                    </>
                  ) : currentTtn ? (
                    <>
                      <a
                        href={`https://tracking.novaposhta.ua/#/ua?cargo_number=${currentTtn}`}
                        target="_blank"
                        rel="noreferrer"
                        className={styles.ttnLink}
                      >
                        {currentTtn}
                      </a>

                      {canEditTtn && (
                        <button
                          type="button"
                          className={styles.editBtn}
                          onClick={() => beginEditTTN(order)}
                        >
                          Змінити
                        </button>
                      )}
                    </>
                  ) : canEditTtn ? (
                    <button
                      type="button"
                      className={styles.addBtn}
                      onClick={() => beginEditTTN(order)}
                    >
                      Додати ТТН
                    </button>
                  ) : (
                    <span>— (доступно після статусу «Взято в роботу»)</span>
                  )}
                </div>
                <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
                  <button
                    type="button"
                    className={styles.editBtn}
                    onClick={() => beginEditItems(order)}
                  >
                    Редагувати позиції
                  </button>

                  {editingItemsId === id && (
                    <button
                      type="button"
                      className={styles.cancelBtn}
                      onClick={cancelEditItems}
                    >
                      Закрити редактор
                    </button>
                  )}
                </div>
                <h4>Позиції ({choice.length})</h4>

                {editingItemsId === id ? (
                  <div className={styles.itemsEditor}>
                    {itemsDraft.length === 0 && (
                      <div className={styles.empty}>Позицій немає</div>
                    )}

                    {itemsDraft.map((it) => (
                      <div key={it.__key} className={styles.itemEdit}>
                        <div className={styles.itemName}>
                          {it.bookName || it.name || it.productId || "Товар"}
                          {it.isNew && (
                            <span className={styles.badgeNew}>NEW</span>
                          )}
                        </div>

                        <input
                          type="number"
                          min={1}
                          value={it.quantity}
                          onChange={(e) => setItemQty(it.__key, e.target.value)}
                          className={styles.qtyInput}
                        />

                        <button
                          type="button"
                          className={styles.cancelBtn}
                          onClick={() => removeDraftItem(it.__key)}
                        >
                          Видалити
                        </button>
                      </div>
                    ))}

                    <div
                      className={styles.addLine}
                      style={{ gridTemplateColumns: "1fr 90px 110px" }}
                    >
                      <ProductPicker
                        styles={styles}
                        value={pickedProduct}
                        onChange={setPickedProduct}
                        placeholder="Оберіть книгу…"
                      />

                      <input
                        type="number"
                        min={1}
                        value={addQty}
                        onChange={(e) =>
                          setAddQty(Math.max(1, Number(e.target.value) || 1))
                        }
                        className={styles.qtyInput}
                      />

                      <button
                        type="button"
                        className={styles.saveBtn}
                        onClick={() => {
                          if (!pickedProduct?.id) {
                            Swal.fire({
                              icon: "info",
                              title: "Оберіть книгу зі списку",
                            });
                            return;
                          }
                          addDraftItem(pickedProduct, addQty); // <-- важливо: передаємо product і qty
                          setPickedProduct(null);
                          setAddQty(1);
                        }}
                      >
                        Додати
                      </button>
                    </div>

                    <div className={styles.editorActions}>
                      <button
                        type="button"
                        className={styles.saveBtn}
                        disabled={savingItems}
                        onClick={async () => {
                          try {
                            const resp = await saveItems(
                              id,
                              order?.paymentMethod || order?.pay,
                            );

                            if (resp?.invoiceUrl) {
                              await Swal.fire({
                                icon: "success",
                                title: "Рахунок оновлено",
                                html: `<a href="${resp.invoiceUrl}" target="_blank" rel="noreferrer">Відкрити новий рахунок</a>`,
                              });
                            } else if (resp?.paymentLink) {
                              await Swal.fire({
                                icon: "success",
                                title: "Створено нове посилання LiqPay",
                                html: `<a href="${resp.paymentLink}" target="_blank" rel="noreferrer">${resp.paymentLink}</a>`,
                              });
                            } else {
                              await Swal.fire({
                                icon: "success",
                                title: "Зміни збережено",
                                timer: 900,
                                showConfirmButton: false,
                              });
                            }
                          } catch (e) {
                            Swal.fire({
                              icon: "error",
                              title: "Помилка",
                              text: e?.message || "Не вдалося зберегти",
                            });
                          }
                        }}
                      >
                        {savingItems ? "Збереження..." : "Зберегти"}
                      </button>

                      <button
                        type="button"
                        className={styles.cancelBtn}
                        disabled={savingItems}
                        onClick={cancelEditItems}
                      >
                        Скасувати
                      </button>
                    </div>
                  </div>
                ) : (
                  <>
                    {choice.length === 0 && (
                      <div className={styles.empty}>Позицій немає</div>
                    )}

                    {choice.map((el, i) => {
                      const price = getItemFinalUnitPrice(el);
                      const qty = Number(el?.quantity ?? el?.qty ?? 1) || 1;

                      return (
                        <div key={i} className={styles.item}>
                          <div className={styles.itemName}>
                            {el?.bookName || el?.name || `Товар ${i + 1}`}
                          </div>
                          <div className={styles.itemQty}>x{qty}</div>
                          <div className={styles.itemPrice}>
                            {safeMoney(price)}
                          </div>
                        </div>
                      );
                    })}

                    {/* якщо card і є новий paymentLink — покажемо його */}
                    {order?.paymentLink &&
                      !isPaidOrder(order) &&
                      Number(order?.dueAmount || 0) > 0 && (
                        <div className={styles.payLinkBox}>
                          <div style={{ marginBottom: 6 }}>
                            <b>Посилання для оплати:</b>
                          </div>

                          <a
                            href={order.paymentLink}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {order.paymentLink}
                          </a>

                          <button
                            type="button"
                            className={styles.saveBtn}
                            style={{ marginTop: 8 }}
                            onClick={() => copyToClipboard(order.paymentLink)}
                          >
                            Скопіювати
                          </button>
                        </div>
                      )}
                  </>
                )}
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}
